import {useCallback} from "react";
import {
	SelectField,
} from "~/components/Forms";

function SamplesSearchBar({filter, onChange}) {

	const categoriesOption = [
		{ label: "Tất cả", value: 0 },
		{ label: "Slider", value: 1 },
		{ label: "Items", value: 5 },
		{ label: "Giới thiệu", value: 6 },
		{ label: "Sản phẩm", value: 3 },
		{ label: "Danh mục sản phẩm", value: 2 },
		{ label: "Tin tức", value: 4 },
		{ label: "Banner", value: 15 },
		{ label: "Feedback", value: 7 },
		{ label: "Gallery", value: 8 },
		{ label: "Video", value: 9 },
		{ label: "Tiện ích", value: 10 },
		{ label: "Email", value: 11 },
		{ label: "Form", value: 16 },
		{ label: "Question", value: 13 },
		{ label: "Footer", value: 14 },
		{ label: "Mạng xã hội", value: 12 },
	]

	const handleCategoryChange = useCallback((value) => {
		if(onChange) onChange('category', value);
	}, [onChange]);

	return (
		<div className="search-bar">
			<div className="container">
				<form className="form" autoComplete="off">
					<SelectField value={filter.category} placeholder="Loại Widget" options={categoriesOption} onChange={handleCategoryChange} />
				</form>
			</div>
		</div>
	)
}

export default SamplesSearchBar;